import { render, staticRenderFns } from "./ClaimRciClassEnrich.vue?vue&type=template&id=3aa76fec&scoped=true&"
import script from "./ClaimRciClassEnrich.vue?vue&type=script&lang=js&"
export * from "./ClaimRciClassEnrich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa76fec",
  null
  
)

export default component.exports